$(document).ready(function (){

    $("#login-modal form.login-form").on("submit", function (e){
        e.preventDefault();
        var postData = $("#login-modal form.login-form").serialize();
        var postUrl  = $("#login-modal form.login-form").attr("action");
        var button   = $(this).find("button[type='submit']");

        $(button).attr("disabled", "true");

        // Hide errors if any of previous login attempt.
        if($("#login-modal .alert-append .callout").length){
            $("#login-modal .alert-append .callout").slideUp();
        }

        $.ajax({
                url: postUrl,
                type: 'POST',
                crossDomain : false,
                data: postData,

                success:function(data){
                    console.log("[Regular login] Success! || " +data);
                    window.location = data;

                    // Remove disabled at button.
                    $(button).removeAttr("disabled");
                },
                error: function (data) {
                    console.log("[LOGIN FAILED]: "+data);
                    data = $.parseJSON(data.responseText);
                    
                    // Loop the errors!
                    var alertBox = "<div class=\"callout alert newAlert\" data-closable> \
                                        <p class=\"message\"></p> \
                                    </div>";

                    $.each(data, function(key, value) {
                        $(alertBox).clone().appendTo("#login-modal .alert-append"); // create new callout and place it in the alert append.
                        $("#login-modal .alert-append .newAlert p.message").text(value); // set alert text.
                        $("#login-modal .alert-append .newAlert").removeClass("newAlert"); // remove the new class.
                    });

                    // Hide alerts after 3000ms.
                    setTimeout(function (){
                        $("#login-modal .alert-append .callout").slideUp();
                    }, 3000);

                    // Remove disabled at button.
                    $(button).removeAttr("disabled");
                }
            });
        }); 

}); // Doc Ready.


// WEBPACK FOOTER //
// ./assets/js/login-reveal.js